import styleConfig from '../../muiTheme';

const styles = () => {
  const {
    palette: {
      primary: { primaryBlue7, primaryBlue, primaryBlue2 },
      white,
    },
  } = styleConfig;
  return {
    headerWithMenu: {
      background: `linear-gradient(to bottom, ${primaryBlue7} 0%, ${primaryBlue} 53%, ${primaryBlue2} 100%)`,
      display: 'flex',
      flexDirection: 'row !important',
      alignItems: 'center',
      padding: '0 24px 0 16px',
      boxShadow: 'none',
    },
    headerLogosWrapper: {
      display: 'flex',
      flex: '1',
      alignItems: 'center',
      justifyContent: 'space-between',
      padding: '0 0 0 24px',
      margin: '3px 0 3px 24px',
      height: '72px',
      borderLeft: `1px solid ${white}`,
    },
    SvgIcon: { color: white, height: '25px', width: '25px' },
    homeTxtStyle: { marginLeft: 20, color: white, fontSize: 20 },
    appHeader: { color: white },
    logoStyle: { width: 144, marginTop: 5, marginRight: 12 },
  };
};

export default styles;
